module.exports = __webpack_public_path__ + "img/jig_brain_structure_function_coupling.83a8cbc1.jpg";